import Vue from 'vue';
import vuexI18n from 'vuex-i18n';

import dictionary from '@/i18n';
import clickOutsideDirective from '@/utils/clickOutsideDirective';
import App from './App.vue';
import router from './router';
import store from './store';

import './styles/main.scss';

Vue.config.productionTip = false;

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('en', dictionary.en);
Vue.i18n.set('en');

Vue.directive('click-outside', clickOutsideDirective);

new Vue({
    router,
    store,
    components: {
        App,
    },
    render: (h) => h(App),
}).$mount('#app');
